import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import 'swiper/swiper.min.css';
import 'swiper/swiper-bundle.min.css';

window.onload = function() {
  const cityIds = ["hiw_london", "hiw_lisbon", "hiw_barcelona"];
  
  cityIds.forEach((id) => {
    const tabElement = document.getElementById(id);
    if (!tabElement) {
      return;
    }

    const swiperContainer = tabElement.querySelector('.swiper');
    if (!swiperContainer) {
      return;
    }
    
    const nextButton = tabElement.querySelector('.next button');
    const prevButton = tabElement.querySelector('.previous button');
    
    if (!nextButton || !prevButton) {
      return;
    }
    
    const swiper = new Swiper(`#${id} .swiper`, {
      modules: [Navigation],
      slidesPerView: 1,
      spaceBetween: 20,
      navigation: {
        nextEl: `#${id} .next button`,
        prevEl: `#${id} .previous button`,
      },
      breakpoints: {
        640: {
          slidesPerView: 2,
          spaceBetween: 20
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 20
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 20
        }
      }
    });

    swiper.on('slideChange', function() {      
      if (swiper.isBeginning) {
        prevButton.classList.add('disabled');
        prevButton.disabled = true;
      } else {
        prevButton.classList.remove('disabled');
        prevButton.disabled = false;
      }
      
      if (swiper.isEnd) {
        nextButton.classList.add('disabled');
        nextButton.disabled = true;
      } else {
        nextButton.classList.remove('disabled');
        nextButton.disabled = false;
      }
    });

    if (swiper.isBeginning) {
      prevButton.classList.add('disabled');
      prevButton.disabled = true;
    }
    
    if (swiper.isEnd) {
      nextButton.classList.add('disabled');
      nextButton.disabled = true;
    }
  });
};